<slick-tabs [hideBorder]="true">
	<slick-tab *ngIf="canViewUserNotes === true" header="<i class='far fa-user'></i>&nbsp;Account Notes">
		<notes #userNotes noteType="BusinessDevelopment" [businessDevelopmentAccountId]="businessDevelopmentAccountId" [suggestedRecipients]="suggestedRecipients" [showSystemNotes]="false" (onNoteAdded)="noteAdded()" [emailHeader]="emailHeader" [emailFooter]="emailFooter"></notes>
	</slick-tab>

	<slick-tab *ngIf="canViewSystemNotes === true" header="<i class='fal fa-cogs'></i>&nbsp;System Notes">
		<notes #systemNotes noteType="BusinessDevelopment" [businessDevelopmentAccountId]="businessDevelopmentAccountId" [showSystemNotes]="true"></notes>
	</slick-tab>
</slick-tabs>

